<template>
  <div id="app">
    <Vue3Lottie
      ref="lottieAnimation"
      :animationData="animation"
      :loop="false"
      :height="height"
      :width="width"
      :autoPlay="false"
      @onAnimationLoaded="onLottieReady"
      @onComplete="onAnimationComplete"
    />
  </div>
</template>

<script>
import { Vue3Lottie } from 'vue3-lottie';

export default {
  components: {
    Vue3Lottie,
  },
  props: {
    animation: {
      type: Object,
      required: true,
    },
    height: {
      required: false,
      default: 'auto'
    },
    width: {
      required: false,
      default: 'auto'
    }
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    onLottieReady() {
      const anim = this.$refs.lottieAnimation;

      anim.goToAndStop(0, true);

      this.startVisibilityObserver();
    },
    onAnimationComplete() {
      const anim = this.$refs.lottieAnimation;
      anim.goToAndStop(anim.totalFrames - 1, true);
    },
    startVisibilityObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true;
            this.playAnimation();
          }
        });
      });
      observer.observe(this.$el);
    },
    playAnimation() {
      const anim = this.$refs.lottieAnimation;
      if (this.isVisible) {
        anim.play();
      }
    },
  },
  beforeDestroy() {
    const anim = this.$refs.lottieAnimation;
    if (anim) {
      anim.removeEventListener('complete', this.onAnimationComplete);
    }
  },
};
</script>

<style scoped></style>
